import { DatePipe } from "@angular/common";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { Component, OnInit } from "@angular/core";
import {
    FormBuilder,
    FormControl,
    FormGroup,
    Validators,
} from "@angular/forms";
import { ActivatedRoute, Router } from "@angular/router";
import { LocalStorageService, SessionStorageService } from "ngx-webstorage";
import { MessageService } from "primeng/api";
import "rxjs/Rx";
import { environment } from "src/environments/environment";
import { MyserviceService } from "../myservice.service";

@Component({
    selector: "app-add-scheduler",
    templateUrl: "./add-scheduler.component.html",
    styleUrls: ["./add-scheduler.component.css"],
    providers: [MessageService],
})
export class AddSchedulerComponent implements OnInit {
    scheduleArray = [];
    statusArray = [];
    activeUsersArray = [];
    document: any = {};
    editResponse: any = {};
    searchData: any = [];
    updateSchedulerResponse: any = [];
    detailInfoData: any = [];
    schedulerTimeList: any = [];
    TRANSACTION_TYPE: any = [];
    SENDERS: any = [];
    RECEIVERS: any = [];
    activeUsers: any = [];
    userList: any = [];
    addStatus = "";
    public responseViewTime: boolean = false;
    public show: boolean = false;
    public count = 0;
    externalEmails = [];
    addschedulerForm: FormGroup;
    userRole: string;
    constructor(
        private myservice: MyserviceService,
        private router: Router,
        private route: ActivatedRoute,
        public localstorage: LocalStorageService,
        public session: SessionStorageService,
        private http: HttpClient,
        public datepipe: DatePipe,
        private fb: FormBuilder,
        private messageService: MessageService
    ) {}

    ngOnInit() {
        this.userRole = this.session.retrieve("userRole");
        this.addschedulerForm = this.fb.group({
            title: new FormControl("", Validators.required),
            type: new FormControl("", Validators.required),
            receiverEmails: new FormControl("", Validators.required),
            externalEmails: new FormControl("", Validators.required),
            status: new FormControl("", Validators.required),
        });

        this.scheduleArray.push({ label: "Select", value: "-1" });
        this.scheduleArray.push({ label: "Daily", value: "Daily" });
        this.scheduleArray.push({ label: "Weekly", value: "Weekly" });
        this.scheduleArray.push({ label: "Monthly", value: "Monthly" });

        this.statusArray.push({ label: "Select", value: "-1" });
        this.statusArray.push({ label: "Active", value: "Active" });
        this.statusArray.push({ label: "InActive", value: "InActive" });

        this.addStatus = null;
        this.document.title = "";
        this.document.type = "-1";
        this.document.hours = "-1";
        this.document.status = "-1";
        this.document.receiverEmails = "";
        this.document.reportsType = "-1";
        this.document.format = "-1";
        this.document.emails = "";

        this.myservice
            .activeUsers(this.localstorage.retrieve("token"))
            .subscribe((data) => {
                this.activeUsers = data;

                let keys = Object.keys(data);
                for (var i = 0; i < keys.length; i++) {
                    this.activeUsersArray.push({
                        label: keys[i],
                        value: data[keys[i]],
                    });
                }
            });
        this.externalEmails = [];
    }
    add(documentForm) {
        let document = documentForm.value;
        document.createdBy = this.session.retrieve("UserDetails").loginId;
        document.receiverEmails = document.receiverEmails.toString();
        document.externalEmails = document.externalEmails.toString();

        let headers = new HttpHeaders();
        headers = headers.append(
            "Authorization",
            this.localstorage.retrieve("token")
        );

        headers = headers.append("Content-Type", "application/json");
        this.http
            .post(environment.apiUrl + "/scheduler/add", document, {
                headers: headers,
                responseType: "text",
            })
            .subscribe((data) => {
                this.addStatus = data;
                if (this.addStatus == "") {
                    this.messageService.add({
                        severity: "error",
                        summary: "Error",
                        detail: this.addStatus,
                    });
                } else {
                    this.messageService.add({
                        severity: "success",
                        summary: "Success",
                        detail: this.addStatus,
                    });
                }
                this.responseViewTime = true;
                setTimeout(
                    function () {
                        this.responseViewTime = false;
                    }.bind(this),
                    2000
                );
            });
    }

    backToList() {
        this.router.navigate(["/scheduler", { flag: "back" }]);
    }

    reset() {
        this.addschedulerForm.reset();
    }
}
